import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getParentCategories } from "../../redux/slices/category/categorySlice";
import { dispatch } from "../../redux/store";
import defaultImage from "../../assets/png/defaultImage.png";
import { UPDATE, updateFilters } from "../../redux/slices/filter/filterSlice";
import { useNavigate } from "react-router-dom";
import Loader from "../common/Loader";
import { FaArrowLeft } from "react-icons/fa6";
import { FaArrowRight } from "react-icons/fa6";

const CategoriesList = ({
  title = "Shop By Category",
  showViewAll = false,
  dark = false,
}) => {
  const [scrolled, setScrolled] = useState(false);
  const navigation = useNavigate();
  const { parentCategories, isCategoryLoading } = useSelector(
    (state: any) => state.category
  );
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(getParentCategories());
  }, [dispatch]);

  const handleScrollRight = () => {
    // setScrolled(true)
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: 140,
        behavior: "smooth",
      });
    }
  };

  const handleScrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: -140,
        behavior: "smooth",
      });
    }
  };

  if (isCategoryLoading) {
    return (
      <div className="w-full flex items-center justify-center">
        <Loader />
      </div>
    );
  }

  return (
    <div className="p-2 sm:p-4 mt-4 sm:mt-8 w-full flex flex-col gap-5">
      {/* Header Section */}
      <div className="flex items-center justify-center relative mb-4 sm:mb-6 w-full">
        <div className="flex flex-col items-center gap-1">
          <p className="text-black font-Poppins text-center font-semibold text-[40px]">
            {title}
          </p>
          <div className="flex gap-1 justify-center">
            <div className="h-1 w-3 bg-[#05A30D] opacity-30"></div>
            <div className="h-1 w-8 bg-[#05A30D]"></div>
            <div className="h-1 w-3 bg-[#05A30D] opacity-30"></div>
          </div>
        </div>
      </div>

      <div
        // onWheel={(e) => e.preventDefault()}
        className="flex sm:gap-2 md:gap-4 lg:gap-6 py-1 h-fit items-center w-full overflow-visible"
      >
        <button
          onClick={handleScrollLeft}
          className="h-fit transition-all rounded-full p-2 bg-white shadow-custom border-[1px] hover:shadow-[#05A30D] text-[#05A30D] active:bg-[#05A30D] active:text-white active:scale-95 hover:scale-105 hover:opacity-60 flex items-center gap-1 text-sm sm:text-base"
        >
          <FaArrowLeft className="w-4 h-4 sm:w-5 sm:h-5 " />
        </button>
        <div
          ref={scrollContainerRef}
          className="flex-grow px-1 scroll-mx-2 flex gap-2 py-2 overflow-x-scroll scrollbar-hide snap-x"
        >
          {parentCategories.map((category: any) => {
            // console.log(category);
            return (
              <div
                onClick={() => {
                  dispatch(
                    UPDATE({
                      title: "Category",
                      value: category.id,
                    })
                  );
                  navigation(`/products?categoryId=${category.id}`);
                }}
                key={category.id}
                className="bg-white overflow-hidden transition-all flex flex-col items-center scroll-ml-2 border-[1px] hover:shadow-custom snap-start rounded-lg hover:shadow-[#05A30D] aspect-square h-auto hover:scale-105 duration-200 cursor-pointer min-w-[100px] min-h-[110px] md:min-w-[130px] lg:min-w-[160px] "
              >
                <div className="p-2 md:p-4 min-h-[80px] md:min-h-[100px] aspect-square w-full overflow-hidden">
                  <img
                    src={category.image ?? defaultImage}
                    alt={category.name}
                    className=" h-full aspect-square object-cover mx-auto"
                  />
                </div>
                <div className="p-1 text-center">
                  <span
                    className={`text-xs text-ellipsis md:text-sm font-medium ${
                      dark ? "text-gray-300" : "text-gray-900"
                    }`}
                  >
                    {category.name}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
        <button
          onClick={handleScrollRight}
          className=" h-fit rounded-full p-2 transition-all bg-white border-[1px] hover:shadow-[#05A30D] text-[#05A30D] active:bg-[#05A30D] active:text-white active:scale-95 hover:scale-105 hover:opacity-60 shadow-custom  flex items-center gap-1 text-sm sm:text-base"
        >
          <FaArrowRight className="w-4 h-4 sm:w-5 sm:h-5 font-bold" />
        </button>
      </div>
    </div>
  );
};

export default CategoriesList;
